document.addEventListener("DOMContentLoaded", function () {
  const elem = document.querySelector('#birthDate');
  const datepicker = new Datepicker(elem, {
    format: 'dd-mm-yyyy'
  });

  document.getElementById("braceletForm").addEventListener("submit", async function (event) {
    event.preventDefault();

    const name = document.getElementById("name").value.trim(),
    email = document.getElementById("email").value.trim(),
    phone = document.getElementById("phone").value.trim(),
    chartType = document.getElementById("chartType").value,
    birthDate = document.getElementById("birthDate").value,
    birthTime = document.getElementById("birthTime").value,
    countryCode = document.getElementById("country-code").value,
    birthPlace = document.getElementById("birthPlace").value.trim(),
    birthLat = document.getElementById("birthPlace").getAttribute("data-latitude"),
    birthLong = document.getElementById("birthPlace").getAttribute("data-longitude"),
    purpose = (chartType == 'purpose') ? document.getElementById("purpose").value.trim() : "";

    let dateArr = birthDate.split("-");
    let formattedDate = `${dateArr[2]}/${dateArr[1]}/${dateArr[0]}`;

    const phoneRegex = /^[0-9]{10}$/;
    const weightRegex = /^[0-9]+$/;

    if (!name) {
      alert("Name is required.");
      return;
    }

    if (!email.includes("@") || !email.includes(".")) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!phoneRegex.test(phone)) {
      alert("Phone number must be 10 digits.");
      return;
    }

    if (!chartType) {
      alert("Please select your chartType.");
      return;
    }

    if (!birthDate) {
      alert("Birth date is required.");
      return;
    }

    if (!birthPlace) {
      alert("Birth place is required.");
      return;
    }

    var urlParams = {
      full_name: name,
      birth_date: formattedDate,
      birth_time: chartType == 'birth' ? birthTime : "",
      birth_place: birthPlace,
      birth_lat: birthLat,
      birth_long: birthLong,
      chart_type: chartType,
      user_email: email,
      user_number: phone,
      country_code: countryCode,
      purpose: purpose,
      source_type: 'gems_web'
    };
    // console.log(urlParams);

    const button = document.querySelector('#braceletForm button[type="submit"]');
    button.classList.add('loading');
    button.disabled = true;

    const apiEndpoint = "https://api.astroarunpandit.org/verified-bracelet-info";
    urlParams = new URLSearchParams(urlParams);
    await fetch(apiEndpoint + "?" + urlParams)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        renderbraceletHtml(data);
  
        // ✅ ADD THIS LINE
        if (window.trackBraceletProducts) {
          window.trackBraceletProducts(data);
        }

        button.classList.remove('loading');
        button.disabled = false;
      })
      .catch((error) => {
        console.log("Error:", error);
        button.classList.remove('loading');
        button.disabled = false;
        // document.getElementById("loader").style.display = "none";
      });
  });

  document.getElementById("birthPlace").addEventListener("input", function () {
    var birthPlaceValue = this.value;
    birthPlaceValue = birthPlaceValue.replace(/[^a-zA-Z\\s]/g, "");
    const cityNameProcess = document.getElementById("cityNameProcess");
    const timeZonesValue = document.getElementById("timeZonesValue");

    cityNameProcess.innerHTML = "<small>Enter Village, Block or City Name here<small>";
    let valueFlag = false;

    if (birthPlaceValue.length > 3) {
      cityNameProcess.innerHTML = '<b style="color:green;">Loading address details...<b>';
      // const apiUrl = `https://api.mapbox.com/search/geocode/v6/forward?q=${birthPlaceValue}&proximity=ip&access_token=pk.eyJ1IjoiZGl2eWFuc2h1a21yOTEiLCJhIjoiY21hM2pyenp4MjQ4czJvc2dnOTlhcW11diJ9.YO1a_xIwfA2m4dJdx3RtKg`;
      const apiUrl = `https://api-geocode.obrio.net/v1/autocomplete?text=${birthPlaceValue}`;

      fetch(apiUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log(data);
          timeZonesValue.innerHTML = "";

          // Mapbox
          /*const suggestions = data.features.map((result) => ({
            address: result.properties.full_address,
            coordinates: [result.properties.coordinates.latitude, result.properties.coordinates.longitude],
          }));*/

          // OpenSource
          const suggestions = data.features.map((result) => ({
            address: `${result.properties.name}, ${result.properties.region}, ${result.properties.country}`,
            coordinates: [result.geometry.coordinates[1], result.geometry.coordinates[0]],
          }));

          if (suggestions && suggestions.length > 0) {
            suggestions.forEach((suggestion) => {
              const option = document.createElement("li");
              option.innerHTML =suggestion.address;
              option.setAttribute("data-latitude", suggestion.coordinates[0]);
              option.setAttribute("data-longitude", suggestion.coordinates[1]);
              option.setAttribute("data-place", suggestion.address);
              option.addEventListener("click", function () {
                const s_box = document.getElementById("birthPlace");
                s_box.value = suggestion.address;
                s_box.setAttribute("data-latitude", suggestion.coordinates[0]);
                s_box.setAttribute("data-longitude", suggestion.coordinates[1]);
                s_box.setAttribute("data-place", suggestion.address);
                document.getElementById("timeZonesValue").innerHTML = "";
              });
              timeZonesValue.appendChild(option);
            });
          } else {
            cityNameProcess.innerHTML = "<small>No results found</small>";
          }
        })
        .catch((error) => {
          console.error("Error fetching address details:", error);
          cityNameProcess.innerHTML = "<small>Error loading address details</small>";
        });
    }
  });

  document.getElementById("birthPlace").addEventListener("change", function () {
    const selectedOption = Array.from(
      document.getElementById("timeZonesValue").children
    ).find((opt) => opt.value === this.value);

    if (selectedOption) {
      const latitude = selectedOption.getAttribute("data-latitude");
      const longitude = selectedOption.getAttribute("data-longitude");
      const place = selectedOption.getAttribute("data-place");

      this.setAttribute("data-latitude", latitude);
      this.setAttribute("data-longitude", longitude);
      this.setAttribute("data-place", place);

      document.getElementById("cityNameProcess").innerHTML = "Address has been selected";
    }
  });

  document.getElementById("timeZonesValue").addEventListener("input", function () {
    const cityNameProcess = document.getElementById("cityNameProcess");
    cityNameProcess.innerHTML = "";
  });

  /* Get the Country COde for the Phone Number */
  const countryData = "https://cdn.shopify.com/s/files/1/0648/0514/2781/files/country_code_and_details.json";
  fetch(countryData)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }
      return response.json();
    })
    .then((data) => {
      while (document.getElementById("country-code").options.length > 0) {
        document.getElementById("country-code").remove(0);
      }

      const countries = data.countries || [];
      const selectBox = document.getElementById("country-code");

      countries.forEach((country) => {
        const option = document.createElement("option");
        option.value = `+${country.phone_code}`;
        option.textContent = `${country.country_code} (+${country.phone_code})`;

        if (country.country_code === "IN") {
          option.selected = true;
        }

        selectBox.appendChild(option);
      });
    })
    .catch((error) => {
      console.error("Error fetching JSON data:", error);
    });

  function renderbraceletHtml(data) {
    const resultContainer = document.getElementById("result-container");
    resultContainer.innerHTML = "";
    var cardHtml = '';
    console.log(data.result);

    data.result.forEach(item => {
      cardHtml += `
        <div class="card">
          <div class="img-hover-zoom">
            <img src="${item.image}" alt="${item.name}">
          </div>
          <div class="card-content">
            <h2 class="card-title">${item.name}</h2>
            <p class="card-significance">${item.significance}</p>
            <div class="how-to-wear">
              <span><strong>Timing:</strong> ${item.howToWear.timing}</span>
              <span><strong>Mantra:</strong> ${item.howToWear.mantra}</span>
            </div>
            <div class="link-btn">
              <a href="${item.url}" target="_blank">Buy Now</a>
            </div>
          </div>
        </div>
      `;
    });

    const html = `
      <div class="bracelet-cards">
        ${cardHtml}
      </div>
    `;

    resultContainer.innerHTML = html;
    resultContainer.style.display = 'block';

    resultContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  const hoursDropdown = document.getElementById("hours");
  const minutesDropdown = document.getElementById("minutes");
  const ampmDropdown = document.getElementById("ampm");
  const hiddenInput = document.getElementById("birthTime");

  function updateHiddenTime() {
    const hours = parseInt(hoursDropdown.value, 10);
    const minutes = minutesDropdown.value;
    const ampm = ampmDropdown.value;

    let hours24 = hours;
    if (ampm === "PM" && hours !== 12) {
      hours24 += 12;
    } else if (ampm === "AM" && hours === 12) {
      hours24 = 0;
    }
    const formattedHours = hours24.toString().padStart(2, "0");
    const time = `${formattedHours}:${minutes}`;
    console.log(time);
    hiddenInput.value = time;
  }

  hoursDropdown.addEventListener("change", updateHiddenTime);
  minutesDropdown.addEventListener("change", updateHiddenTime);
  ampmDropdown.addEventListener("change", updateHiddenTime);

  const chartTypeElement = document.querySelector('#chartType');
  chartTypeElement.addEventListener("change", function () {
    const selectedValue = chartTypeElement.value;

    const purposeSelect = document.getElementById("purpose");
    const purposeLabel = document.getElementById("purposeLabel");

    if (selectedValue === "purpose") {
      purposeSelect.style.display = "block";
      purposeLabel.style.display = "block";
    } else {
      purposeSelect.style.display = "none";
      purposeLabel.style.display = "none";
    }
  });

  document.querySelector('input[name="time-input"]').addEventListener("change", () => {
    if (document.querySelector('input[name="time-input"]').checked) {
      document.querySelector("#birthTime").disabled = true;
      document.getElementById("hours").disabled = true;
      document.getElementById("minutes").disabled = true;
      document.getElementById("ampm").disabled = true;
    } else {
      document.querySelector("#birthTime").disabled = false;
      document.getElementById("hours").disabled = false;
      document.getElementById("minutes").disabled = false;
      document.getElementById("ampm").disabled = false;
    }
  });
});